import { Header } from '@/components/Header';
import { HeroSection } from '@/components/HeroSection';
import { QuickRules } from '@/components/QuickRules';
import { SubmissionForm } from '@/components/SubmissionForm';
import { DreamBoard } from '@/components/DreamBoard';
import { Footer } from '@/components/Footer';
import { FloatingSubmitButton } from '@/components/FloatingSubmitButton';

const Index = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <HeroSection />
      <QuickRules />
      <SubmissionForm />
      <DreamBoard />
      <Footer />
      <FloatingSubmitButton />
    </div>
  );
};

export default Index;